import { useState } from "react"
import { Slider } from "../ui/Slider";
import { Button } from "../ui/Button";
import { Checkbox, TextField } from "../ui";

export const ServiceOptions = ({handleServiceSubmit,setFormStep}) => {
    const [selectedServices, setSelectedServices] = useState([])
    const [sliderValue, setSliderValue] = useState(0);

    const handleKeyDown = (event) => {
        if (
            !(
            (event.keyCode >= 48 && event.keyCode <= 57) || // Numbers
            (event.keyCode >= 96 && event.keyCode <= 105) || // Numeric keypad
            event.keyCode === 8 || // Backspace
            event.keyCode === 46 || // Delete
            event.keyCode === 37 || // Left arrow
            event.keyCode === 39 // Right arrow
            )
        ) {
            event.preventDefault();
        }
    }

    const handleCheckedOptions = (inputString) => {
        const copyList = [...selectedServices];
        let updatedList = [];
        const stringIndex = copyList.findIndex(item => item === inputString);

        if (stringIndex !== -1) {
            updatedList = [...copyList.slice(0, stringIndex), ...copyList.slice(stringIndex + 1)];
        } else {
            updatedList = [...copyList, inputString];
        }

        const newListHasPaint = updatedList.findIndex(item => item === 'bodyWork') !== -1;
        const newListHasTyre = updatedList.findIndex(item => item === 'tyreChange') !== -1;
        const newListHasService = updatedList.findIndex(item => item === 'standarizedService') !== -1;


        if (newListHasPaint && newListHasTyre && !newListHasService) {
            updatedList = updatedList.filter(item => item !== 'bodyWork')
        }
        setSelectedServices(updatedList);
    }

    return (
        <div className="flex flex-col gap-10 relative">
            <div className="max-lg:w-full max-lg:my-5 order-last lg:absolute flex max-lg:flex-col-reverse gap-4 lg:gap-10 lg:-top-[60px] lg:right-0">
                <Button className={'border border-[#A5A5A5] py-3 px-10 rounded-[6px] text-primary-button'} onClick={()=> {setFormStep(0)}}>Ακύρωση</Button>
                <Button disabled={selectedServices.length===0 || sliderValue === 0 || sliderValue === ''} className={'disabled:bg-[#A5A5A5] rounded-[6px] bg-[#D4002A] py-3 px-10 text-primary-button text-white'} onClick={()=>{handleServiceSubmit({mileage:sliderValue,selectedServices:selectedServices})}}>Επόμενο</Button>
            </div>
            <div className="bg-white rounded-[12px] flex flex-col gap-6 xl:min-w-[600px] p-6">
                <div className="flex flex-col gap-3">
                    <h4>Χιλιόμετρα</h4>
                    <p className="text-body-large">Συμπλήρωσε τα χιλιόμετρα του αυτοκινήτου:</p>
                </div>
                <div className="flex justify-between items-center">
                    <h5>Χιλιόμετρα</h5>
                    <div className="flex relative items-center">
                    <TextField
                        autocomplete="off"
                        defaultValue={sliderValue}
                        onChange={(e) => {
                            setSliderValue(e.target.value)
                            }}
                            min={0}
                            onKeyDown={handleKeyDown} 
                        type={'number'}
                            value={sliderValue}  
                        className={'pr-10 w-[124px]'}    
                    />
                    <p className="absolute right-[10px]">χλμ</p>
                    </div>
                </div>
                <div className="w-full">
                    <Slider value={[sliderValue]} onValueChange={(value)=> setSliderValue(value[0])} defaultValue={[0]} max={300000} step={2500} />
                </div>
            </div>
            <div>
                <h4>Τύπος εργασίας</h4>
                <div className="lg:p-6 pt-6 grid lg:grid-cols-3 gap-4">
                <div className="w-full bg-white rounded-[12px] p-4 flex lg:flex-col lg:justify-between lg:h-[140px]" style={{
                        boxShadow: '0px 2px 6px 0px #63636333'
                    }} >
                        <h6>Ετήσιο ή έκτακτο
service</h6>
                        <div className="w-full flex justify-end">
                            <Checkbox
                            checked={selectedServices.findIndex(item => item === 'standarizedService') !== -1}
                            onCheckedChange={() => {handleCheckedOptions('standarizedService') }} />
                        </div>
                    </div>
                    <div className="w-full max-lg:justify-between bg-white rounded-[12px] p-4 flex lg:flex-col lg:justify-between lg:h-[140px]" style={{
                        boxShadow: '0px 2px 6px 0px #63636333'
                    }} >
                        <h6>Αλλαγή Ελαστικών</h6>
                        <div className="lg:w-full flex justify-end">
                            <Checkbox
                                checked={selectedServices.findIndex(item => item === 'tyreChange') !== -1}
                                onCheckedChange={() => { handleCheckedOptions('tyreChange') }} />
                        </div>
                    </div>
                    {selectedServices.findIndex(item => item === 'tyreChange') !== -1 && selectedServices.length === 1 ? <></>:
                        <div className="w-full bg-white rounded-[12px] p-4 flex lg:flex-col lg:justify-between lg:h-[140px]" style={{
                            boxShadow: '0px 2px 6px 0px #63636333'
                        }} >
                            <h6>Φανοποιία</h6>
                            <div className="w-full flex justify-end">
                                <Checkbox
                                     checked={selectedServices.findIndex(item => item === 'bodyWork') !== -1}
                                    onCheckedChange={() => { handleCheckedOptions('bodyWork') }} />
                            </div>
                        </div>
                    }
                </div>
            </div>
        </div>
    )
}